import { render } from "./PermissionDeniedDialog.vue?vue&type=template&id=4654d213&scoped=true"
import script from "./PermissionDeniedDialog.vue?vue&type=script&lang=js"
export * from "./PermissionDeniedDialog.vue?vue&type=script&lang=js"

import "./PermissionDeniedDialog.vue?vue&type=style&index=0&id=4654d213&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4654d213"]])

export default __exports__